import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { Switch, Typography } from '@mui/material';
import { ArrowBackIos } from '@mui/icons-material';
import { Timeline } from '../../components/timeline/timeline';
import {
  useGetLZByDeviceIdMutation,
  useGetTimelineByDeviceIdMutation
} from '../../services/device/deviceService';
import { Header } from '../../components/header/header';
import {
  ContainerTable,
  StyledHeaderContainer,
  StyledTitleHeader
} from '../../components/layout/main/mainStyles';
import Strings from '../../i18n';
import { ButtonIconStyled } from '../devices/devicesStyles';
import DataDownloader from '../../components/timeline/csvDownloader/csvDownloader';

export const TimelineLightZonesView = () => {
  const { deviceId, locationId } = useParams();
  const navigate = useNavigate();
  const [showControls, setShowControls] = useState(false);
  const [selectedLZ, setSelectedLZ] = useState<{
    id: number;
    name: string;
    isZone: boolean;
  }>({ id: 0, name: '', isZone: false });
  const [
    getTimelineByDeviceId,
    { data: timelineData, isSuccess: isSuccessTimelineData }
  ] = useGetTimelineByDeviceIdMutation();

  const [getLZByDeviceId, { data: lzData, isSuccess: isSuccessLZData }] =
    useGetLZByDeviceIdMutation();

  useEffect(() => {
    getLZByDeviceId(deviceId as string);
  }, [deviceId]);

  const handleLZChange = (e: DropdownChangeEvent) => {
    setSelectedLZ(e.value);
    getTimelineByDeviceId({
      deviceId: deviceId as string,
      isZone: e.value.isZone,
      lightZoneId: e.value.id
    });
  };

  return (
    <>
      <Header>
        <StyledHeaderContainer>
          <div className="row justify-content-between">
            <div className="col-1 col-sm-4 text-left">
              <ButtonIconStyled
                size="small"
                onClick={() =>
                  navigate(`/locations/${locationId}/applications/connectivity`)
                }
              >
                <ArrowBackIos />
              </ButtonIconStyled>
            </div>
            <div className="col-6 col-sm-4 text-center">
              <StyledTitleHeader align="center">
                {Strings.timeline.timeline}
              </StyledTitleHeader>
            </div>
            <div className="col-5 col-sm-4 text-right">
              <div>
                <span>Show Controls</span>
                <Switch
                  checked={showControls}
                  onChange={() => setShowControls(!showControls)}
                />
                {timelineData && (
                  <DataDownloader
                    data={timelineData}
                    selectedId={selectedLZ.id}
                  />
                )}
              </div>
            </div>
          </div>
        </StyledHeaderContainer>
      </Header>
      <div className="row">
        <div className="col-12 text-center d-flex justify-content-around align-items-center">
          <Dropdown
            value={selectedLZ}
            onChange={handleLZChange}
            options={lzData || []}
            optionLabel="name"
            placeholder="Select a Light Zone"
            className="w-full md:w-14rem"
          />
        </div>
        <div className="col-12">
          <ContainerTable component="main">
            <Typography variant="h6" sx={{ marginLeft: 5, marginTop: 2 }}>
              Timezone: {timelineData?.timeZone}
            </Typography>
            <Timeline
              data={timelineData?.timeline || {}}
              showControls={showControls}
            />
          </ContainerTable>
        </div>
      </div>
    </>
  );
};
